// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* Overrides for the CssBaseline Material-UI component */\n\nbody {\n  background-color: #eee;\n}\n", "",{"version":3,"sources":["webpack://./src/cssbaseline-overrides.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;EACE,sBAAsB;AACxB","sourcesContent":["/* Overrides for the CssBaseline Material-UI component */\n\nbody {\n  background-color: #eee;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
